import { ROUTES_NEW_ROOT, ROUTES_ROOT } from './routesRoot';

// роуты next.js приложения (должны соответствовать файлам в /src/pages)
export const APP_ROUTES = {
  loansRates: `${ROUTES_ROOT}/rates`,
  loansOffers: `${ROUTES_ROOT}/offers`,
  newForm: `${ROUTES_ROOT}/form`,
  newFormWL: `${ROUTES_ROOT}/formWhiteLabel`,
  vitrins: `${ROUTES_ROOT}/vitrins`,
  loansSeoLanding: `${ROUTES_ROOT}/loansSeoLanding`,
  completedDeal: `${ROUTES_ROOT}/creditCompletedDeal`,
  creditCardsSeoLanding: `${ROUTES_ROOT}/creditCardsSeoLanding`,
  fullDeal: `${ROUTES_ROOT}/creditFullDeal`,
  productForm: `${ROUTES_NEW_ROOT}/productForm`,
  productStatus: `${ROUTES_NEW_ROOT}/productStatus`,
  product: `${ROUTES_NEW_ROOT}/product`,
} as const;
